const levels = [
  {
      "name": "Hall Of Fame $1200",
      "description": [
        "Everything in All Star and MVP for one year!",
        "2 inch x 2 inch logo on the back of promotional shirts given to our clients and children.",
        "Practice Player Of The Week presented by your company posted weekly on all social media platforms.",
        "Weekly social media shoutout on Instagram, - TikTok, Facebook, and Twitter. We’ll also post any content you provide weekly.",
        "One full season of free training for a family of your choice.",
        "Your donation will provide scholarships for 60 children to participate in training sessions.",
        "Your donation will provide scholarships for 6 children to attend summer camp.",
        "606 supporter magnet for your car or refrigerator."
      ]
    },
    



    {
      "name": "MVP $800",
      "description": [
        "Everything in the All Star Package for 6 months. ",
        "Practice Player Of The Week presented by your company posted weekly on all social media platforms.",
        "606 supporter magnet for your car or refrigerator.",
        "Your donation will provide scholarships for 40 children to participate in training sessions.",
        "Your donation will provide scholarships for 4 children to attend summer camp.",
        "606 supporter magnet for your car or refrigerator."
      ]
    }, 

    {
      "name": "All Star $400",
      "description": [
        "Your logo featured on the footer of our website, linking to your company website, 3 Months.",
        "Your logo included in our company email blasts for 3 months year.",
        "Your donation will provide scholarships for 60 children to participate in training sessions.",
        "Your donation will provide scholarships for 6 children to attend summer camp.",
        "One full season of free training for a family of your choice.",
        "606 supporter magnet for your car or refrigerator."
      ]
    },
    {
      "name": "Starter (Any size gift)",
      "description": [
        "If you would like to make any size donation toward the league, please click on \"Sponsor\" above.",
        "All donors will be thanked on our social media platforms.",
        "Starter-level sponsors are eligible for pop-up vendor opportunities at events (space permitting)."
      ]
    }
  ];

 export {levels}
